import { render, staticRenderFns } from "./cart-item.vue?vue&type=template&id=4f54ae2a&scoped=true&"
import script from "./cart-item.vue?vue&type=script&lang=js&"
export * from "./cart-item.vue?vue&type=script&lang=js&"
import style0 from "./cart-item.vue?vue&type=style&index=0&id=4f54ae2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54ae2a",
  null
  
)

export default component.exports